import type { InputHTMLAttributes } from "react";

import "./ui.css";

type SearchInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

export function SearchInput({ className, ...rest }: SearchInputProps) {
  return (
    <div className="filter-bar__search">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <circle cx="11" cy="11" r="7" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input type="search" className={className} {...rest} />
    </div>
  );
}
